module.exports = __webpack_public_path__ + "img/FireExtinguisherOutlined.e2c1cbd0.svg";